module.exports = __webpack_public_path__ + "img/swiper-1.b309fef0.jpg";